import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./scss/index.scss";
import { RichText } from "prismic-reactjs";
import React from "react";
import { useIntl } from "react-intl";
import { linkResolver } from "../../prismic-config";
import { BottomBar } from "../BottomBar";
import { ContactsNav } from "../ContactsNav";
import facebookIcon from "../../../images/footer-icons/facebook.svg";
import instagramIcon from "../../../images/footer-icons/instagram.svg";
export function PrismicFooter(_ref) {
  var title = _ref.title,
      contact = _ref.contact,
      text = _ref.text,
      social = _ref.social,
      navGroups = _ref.navGroups,
      copyright = _ref.copyright,
      terms = _ref.terms,
      isTrustBoxEnabled = _ref.isTrustBoxEnabled;
  var intl = useIntl();
  return React.createElement("footer", {
    className: "footer-wr"
  }, React.createElement("div", {
    className: "footer container"
  }, React.createElement("div", {
    className: "footer__contact footer__nav-groups"
  }, React.createElement("div", {
    className: "footer__subtitle"
  }, title && React.createElement(RichText, {
    render: title
  })), React.createElement("div", {
    className: "footer__text"
  }, text && React.createElement(RichText, {
    render: text
  })), React.createElement(ContactsNav, {
    contact: contact
  }), React.createElement("div", {
    className: "footer-social"
  }, social === null || social === void 0 ? void 0 : social.map(function (item, i) {
    return React.createElement("a", {
      key: i,
      href: linkResolver(item.footer_social_link),
      target: "_blank",
      rel: "noreferrer",
      className: "footer-social__item"
    }, item.footer_social_type === "facebook" && React.createElement("img", {
      src: facebookIcon,
      width: "38px",
      height: "38px",
      alt: item.footer_social_type || "social"
    }), item.footer_social_type === "instagram" && React.createElement("img", {
      width: "38px",
      height: "38px",
      src: instagramIcon,
      alt: item.footer_social_type || "social"
    }));
  }))), navGroups === null || navGroups === void 0 ? void 0 : navGroups.map(function (group, i) {
    var _group$primary, _group$fields;

    return React.createElement("div", {
      key: i,
      className: "footer__nav-groups"
    }, React.createElement("div", {
      className: "footer__subtitle"
    }, (_group$primary = group.primary) === null || _group$primary === void 0 ? void 0 : _group$primary.title), React.createElement("ul", {
      className: "footer__nav"
    }, (_group$fields = group.fields) === null || _group$fields === void 0 ? void 0 : _group$fields.map(function (item, ii) {
      return React.createElement("li", {
        key: ii,
        className: "footer__nav-item"
      }, React.createElement("a", {
        href: linkResolver(item.link)
      }, item.label));
    })));
  }), isTrustBoxEnabled && React.createElement("div", {
    className: "footer__trust-box"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: " Hi! I'm TrustBox! Implement me",
    "id": "@prismic.components.PrismicFooter.PrismicFooter.1842608347"
  }, "id", "@prismic.components.PrismicFooter.PrismicFooter.1842608347")))), React.createElement("div", {
    className: "footer-bottom"
  }, React.createElement("div", {
    className: "container"
  }, React.createElement(BottomBar, {
    copyright: copyright,
    terms: terms
  }))));
}